export const itemsToSentences = items => {
  let sentences = []
  const reducer = (accumulator, currentValue) => {
    if (!currentValue.alternatives.length) {
      return accumulator
    }

    if (!accumulator.startTime) {
      accumulator.startTime = currentValue.startTime
    }

    if (accumulator.sentence && currentValue.type === 'pronunciation') {
      accumulator.sentence = accumulator.sentence + ' '
      accumulator.endTime = currentValue.endTime
    }

    accumulator.sentence =
      accumulator.sentence + currentValue.alternatives[0].content

    if (currentValue.alternatives[0].content.match(/[.?]/)) {
      if (!accumulator.endTime) {
        accumulator.endTime = accumulator.startTime
      }
      sentences.push({
        sentence: accumulator.sentence,
        startTime: accumulator.startTime,
        endTime: accumulator.endTime
      })
      return { sentence: '', startTime: '', endTime: '' }
    } else {
      return accumulator
    }
  }

  items.reduce(reducer, { sentence: '', startTime: '', endTime: '' })

  return sentences
}



// WEBPACK FOOTER //
// ./src/utils/transcript_tools.js